module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "modify_red.cdd3c570.png" + "?" + Date.now();